// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"94":"bfd9e55b","108":"c1b6c981","536":"b45fe7fa","949":"0a2bd5d8"}[chunkId] + ".css";
};